// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__merrieWeatherBlack_b545e2', '__merrieWeatherBlack_Fallback_b545e2', s, e, r, i, f","fontStyle":"normal"},"className":"__className_b545e2"};